module.exports = __webpack_public_path__ + "img/rockwool-cb.396fc9f7.png";